var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWithdrw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29009",
    "data-name": "Group 29009",
    transform: "translate(-158 -250)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1537",
    "data-name": "Ellipse 1537",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(158 250)",
    fill: "rgba(0,142,255,0.1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "atm",
    transform: "translate(175.425 263.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36187",
    "data-name": "Path 36187",
    d: "M61,37.356H78.511V16.126L69.3,0H61Z",
    transform: "translate(-61 0)",
    fill: "#008eff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1542",
    "data-name": "Ellipse 1542",
    cx: 3.328,
    cy: 3.328,
    r: 3.328,
    transform: "translate(19.636 2.163)",
    fill: "#008eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36188",
    "data-name": "Path 36188",
    d: "M395.378,238.92A10.206,10.206,0,0,1,391,242.45v16.394h4.378Z",
    transform: "translate(-366.923 -221.488)",
    fill: "#008eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36189",
    "data-name": "Path 36189",
    d: "M331,130.944a8.758,8.758,0,0,0,8.754-8.88,2.19,2.19,0,0,0-4.377.125A4.382,4.382,0,0,1,331,126.567Z",
    transform: "translate(-311.3 -111.245)",
    fill: "#008eff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrw);
export default __webpack_public_path__ + "static/media/withdrw.f7ab3fa6a07459777f4b4d2d8b34aee3.svg";
export { ForwardRef as ReactComponent };